import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const navLinks = [
  { path: "/", label: "Home" },
  { path: "/about", label: "About" },
  { path: "/services", label: "Services" },
  { path: "/products", label: "Products" },
  { path: "/brands", label: "Brands" },
  { path: "/projects", label: "Projects" },
  { path: "/warranty", label: "Warranty" },
  { path: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl shadow-glass py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="container-custom mx-auto px-6 sm:px-8 lg:px-12 xl:px-24">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-10 h-10 bg-brand-orange rounded-xl flex items-center justify-center transition-transform duration-300 group-hover:scale-110">
              <span className="text-white font-bold text-lg">K</span>
            </div>
            <span className="font-display text-xl font-bold tracking-tight">
              K-Tec<span className="text-brand-orange">.lk</span>
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-xl text-sm font-medium transition-all duration-300 ${
                  location.pathname === link.path
                    ? "bg-brand-orange/10 text-brand-orange"
                    : "text-brand-dark/70 hover:text-brand-dark hover:bg-brand-gray"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="tel:+94762829800"
              className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-brand-dark/70 hover:text-brand-dark transition-colors"
            >
              <Phone size={16} />
              076 282 9800
            </a>
            <Link to="/contact" className="btn-primary !py-2.5 !px-6 !text-sm !rounded-xl">
              Get Quote
            </Link>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-xl hover:bg-brand-gray transition-colors"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <div
        className={`lg:hidden transition-all duration-500 overflow-hidden ${
          isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="glass mx-4 mt-3 rounded-2xl p-4 shadow-glass-lg">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block px-4 py-3 rounded-xl text-sm font-medium transition-all ${
                location.pathname === link.path
                  ? "bg-brand-orange/10 text-brand-orange"
                  : "text-brand-dark/70 hover:text-brand-dark hover:bg-brand-gray"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="mt-3 pt-3 border-t border-brand-border">
            <a
              href="tel:+94762829800"
              className="flex items-center gap-2 px-4 py-3 text-sm font-medium text-brand-dark/70"
            >
              <Phone size={16} />
              076 282 9800
            </a>
            <Link to="/contact" className="btn-primary !py-2.5 w-full mt-2">
              Get Free Consultation
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
